import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

const navLinks = [
  { label: "Home", href: "/" },
  { label: "Services", href: "/services" },
  { label: "About", href: "/about" },
  { label: "Location", href: "/location" },
];

export default function SiteHeader() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location]);

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-500 ${
        scrolled
          ? "bg-pk-ivory/95 backdrop-blur-md border-b border-pk-light/60"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-screen-xl mx-auto px-8 flex items-center justify-between h-[88px]">
        {/* Logo */}
        <Link to="/" className="flex-shrink-0 group" aria-label="Precious Keepsakes Photography">
          <img
            src="https://images-pw.pixieset.com/profile/632184/8e2e397ed4499187d962a6bd1d1c7a5bdb31a2144ecd3aa53b6892fc200e0365.png"
            alt="Precious Keepsakes Photography"
            className={`h-16 w-auto object-contain transition-opacity duration-300 ${scrolled ? "opacity-100" : "opacity-90"}`}
          />
        </Link>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-10">
          {navLinks.map((link) => (
            <Link
              key={link.href}
              to={link.href}
              className={`font-sans text-xs tracking-widest2 uppercase transition-colors duration-300 cursor-pointer whitespace-nowrap relative group ${
                location.pathname === link.href
                  ? "text-pk-gold"
                  : scrolled
                  ? "text-pk-charcoal hover:text-pk-gold"
                  : "text-white/85 hover:text-pk-gold"
              }`}
            >
              {link.label}
              {/* Active underline */}
              <span className={`absolute -bottom-1 left-0 h-px bg-pk-gold transition-all duration-300 ${
                location.pathname === link.href ? "w-full" : "w-0 group-hover:w-full"
              }`} />
            </Link>
          ))}
        </nav>

        {/* Right CTA group */}
        <div className="hidden md:flex items-center gap-6">
          <a
            href="tel:2108154698"
            className={`font-sans text-xs tracking-wide whitespace-nowrap cursor-pointer transition-colors duration-300 flex items-center gap-2 ${
              scrolled ? "text-pk-charcoal hover:text-pk-gold" : "text-white/75 hover:text-pk-gold"
            }`}
          >
            <i className="ri-phone-line text-pk-gold" />
            210-815-4698
          </a>
          <Link
            to="/services"
            className={`font-sans text-xs tracking-widest2 uppercase px-6 py-3 rounded-sm whitespace-nowrap cursor-pointer transition-all duration-300 ${
              scrolled
                ? "bg-pk-gold text-white hover:bg-pk-charcoal"
                : "bg-white/15 border border-white/30 text-white backdrop-blur-sm hover:bg-pk-gold hover:border-pk-gold"
            }`}
          >
            Inquire Now
          </Link>
        </div>

        {/* Mobile menu toggle */}
        <button
          className={`md:hidden text-2xl cursor-pointer transition-colors duration-300 ${
            scrolled ? "text-pk-charcoal" : "text-white"
          }`}
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          <i className={menuOpen ? "ri-close-line" : "ri-menu-3-line"} />
        </button>
      </div>

      {/* Mobile Drawer */}
      <div
        className={`md:hidden overflow-hidden transition-all duration-500 ${
          menuOpen ? "max-h-96" : "max-h-0"
        }`}
      >
        <div className="bg-pk-ivory border-t border-pk-light px-8 py-6 flex flex-col gap-5">
          {navLinks.map((link) => (
            <Link
              key={link.href}
              to={link.href}
              className={`font-sans text-xs tracking-widest2 uppercase transition-colors cursor-pointer ${
                location.pathname === link.href ? "text-pk-gold" : "text-pk-charcoal hover:text-pk-gold"
              }`}
            >
              {link.label}
            </Link>
          ))}
          <div className="border-t border-pk-light pt-4 flex flex-col gap-3">
            <a href="tel:2108154698" className="font-sans text-xs text-pk-gold tracking-wide cursor-pointer flex items-center gap-2">
              <i className="ri-phone-line" /> 210-815-4698
            </a>
            <Link
              to="/services"
              className="bg-pk-gold text-white font-sans text-xs tracking-widest2 uppercase px-6 py-3 rounded-sm text-center cursor-pointer"
            >
              Inquire Now
            </Link>
          </div>
        </div>
      </div>
    </header>
  );
}
